exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  padding-right: 24px; }\n\n.busy *:not(.submit-warn) {\n  opacity: 0.5;\n  z-index: 9999; }\n\n.overlay {\n  position: relative; }\n\nimg.busySpin {\n  margin-top: 48px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 96px; }\n\n.headers h4, .headers h5, .headers input {\n  width: 100%;\n  margin-top: 6px; }\n\n.total-amnt .amnt-cont {\n  text-align: right; }\n  .total-amnt .amnt-cont h5, .total-amnt .amnt-cont h4 {\n    background: #565656; }\n\nhr {\n  margin-top: 24px;\n  border: 0;\n  height: 1px;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0)); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/sales-eod-container/form-sales-eod/form-sales-eod.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/components/sales-eod-container/form-sales-eod/form-sales-eod.component.scss
// module chunks = main